// Example.js